import {DOMAIN} from '@web-catalog/const';

export const removeTrailingSlash = (path: string) => path.replace(/\/$/, '');

export const removeDuplicatedSlashes = (path: string) =>
  path.replace(/\/\//g, '/');

export const pathWithDomain = (path: string) => {
  const domain = process.env.APP_DOMAIN || DOMAIN;
  const joiner = path.startsWith('/') ? '' : '/';

  return removeTrailingSlash([domain, path].join(joiner));
};
